import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { TemplateModel } from "./../models/template.model";
import { TemplateService } from "./../models/template.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  IKeyValueInterface,
  ApplicationRouteURL,
  PermissionType,
  RoleLevel
} from "../../shared/config";
import { Location } from "@angular/common";
import { InstanceService } from "../../instance/models/instance.service";
import { DropdownModel } from "../../report/models/report-filter.model";
import { CustomerService } from "../../customer/models/customer.service";
import { CompanyService } from "../../company/models/company.service";
import { OrganizationService } from "../../organization/models/organization.service";
import { SharedVehicleGroupService } from "../../sharedvehiclegroup/models/sharedvehiclegroup.service";

@Component({
  selector: "wego-template-update",
  template: require('../views/template-update.component.html'),
  providers: [
    TemplateService,
    CustomerService,
    InstanceService,
    CompanyService,
    OrganizationService,
    SharedVehicleGroupService
  ],
  styles: [
    `
    .list-group-item {
      padding: 5px 15px;
    }
    .placeholder-list {
      max-height: 1000px;
      overflow-y: auto;
    }
  `
  ]
})
export class TemplateUpdateComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  CustomerList: DropdownModel[];
  InstanceList: DropdownModel[];
  CompanyList: DropdownModel[];
  OrganizationList: DropdownModel[];
  SVGList: DropdownModel[];
  templateHashId: string;
  sub: any;
  model: TemplateModel;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlTemplateList: string;
  sampleDate: string;
  TemplateNameList: any;
  emailTemplatePlaceHolder: string;
  subjectTemplatePlaceHolder: string;
  pageName: string;
  accessDeniedErrorCode: string;
  roleLevel = RoleLevel;
  permissionType: string;

  private popupMsg: string;
  private SuccessMsg: string;
  private module: string;
  public breadCrumbTitle: string;
  public breadCrumbList: string;
  private isLatexFileDownloadFail: boolean = false;

  @ViewChild("successPopup") public successPopup: any;

  constructor(
    private templateService: TemplateService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    private translate: TranslateService,
    private locationService: Location,
    private customerService: CustomerService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private organizationService: OrganizationService,
    private sharedVehicleGroupService: SharedVehicleGroupService
  ) { }

  ngOnInit() {
    this.pageName = "Template";
    this.accessDeniedErrorCode = "412";
    this.module = this.translate.instant("LblTemplate");
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlTemplateList = this.authService.GetURL(
      ApplicationRouteURL.URL_TEMPLATE_LIST
    );
    this.model = new TemplateModel();
    this.isEditMode = false;
    this.isLatexFileDownloadFail = false;
    this.sub = this.activeRoute.params.subscribe(params => {
      this.templateHashId = params["id"] || "";
      if (this.templateHashId) {
        this.SuccessMsg = this.translate.instant("LblRecordUpdatedSuccess", [
          this.module
        ]);
        this.permissionType = PermissionType.EDIT;
      } else {
        this.SuccessMsg = this.translate.instant("LblRecordAddedSuccess", [
          this.module
        ]);
        this.permissionType = PermissionType.INSERT;
      }

      this.GetCustomerListDropdown();
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  OnSubmit(forms: any) {
    console.log(this.model);
    this.templateService.UpdateTemplate(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.SuccessMsg;
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private MceHtmlOutput($event: any) {
    //console.log($event);
    this.model.bodyHTml = $event;
  }

  private ConvertToSample() {
    this.isLatexFileDownloadFail = false;
    this.sampleDate = this.model.bodyHTml;
    if (this.model.emailTemplatePlaceHolder) {
      this.model.emailTemplatePlaceHolder.forEach(element => {
        if (element.placeHolder != "%ltx_logo%") {
          //this.sampleDate = this.sampleDate.replace(element.placeHolder, element.placeHolderValue);
          this.sampleDate = this.sampleDate.replace(
            new RegExp(element.placeHolder, "g"),
            element.placeHolderValue
          );
        }
      });
    }
  }

  private IsUsedInTemplate(placeholder: string) {
    return this.model.bodyHTml.indexOf(placeholder) > -1;
  }

  private IsUsedInSubject(placeholder: string) {
    return this.model.subjectHTml.indexOf(placeholder) > -1;
  }

  private Copy(className: string) {
    let copyTextarea: any = document.querySelector(className);
    copyTextarea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      console.log("Copying text command was " + msg);
    } catch (err) {
      console.log("Oops, unable to copy");
    }
  }

  public SuccessModalClick(): void {
    this.router.navigate([this.urlTemplateList]);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public GetTemplateByHashId() {
    if (this.templateHashId != "") {
      this.isEditMode = true;
      this.templateService.GetTemplateByHashId(this.templateHashId).subscribe(
        res => {
          this.model = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
    }
  }

  public GetTemplateNames() {
    this.TemplateNameList = [];
    if (!this.templateHashId && this.model.customerHashId) {
      this.model.emailTemplateNameHashId = "";
      this.templateService
        .GetTemplateNameList(
          this.model.customerHashId,
          this.model.instanceHashId,
          this.model.companyHashId,
          this.model.organizationHashId,
          this.model.svgHashId
        )
        .subscribe(
          (res: any) => {
            this.TemplateNameList = res.data;
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    }
  }

  public GetCustomerListDropdown() {
    if (!this.templateHashId) {
      this.customerService
        .GetDropdownCustomerListForTemplate(this.permissionType)
        .subscribe(
          (res: any) => {
            this.CustomerList = res.data;

            if (this.CustomerList != null && this.CustomerList.length > 0) {
              if (!this.model.customerHashId && this.CustomerList.length == 1) {
                this.model.customerHashId = this.CustomerList[0].keyHash;
              }
              this.GetTemplateNames();
              this.OnCustomerChange();
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.GetTemplateByHashId();
    }
  }

  public OnCustomerChange(): any {
    this.model.instanceHashId = "";
    this.InstanceList = [];
    this.model.companyHashId = "";
    this.CompanyList = [];
    this.model.organizationHashId = "";
    this.OrganizationList = [];
    this.model.svgHashId = "";
    this.SVGList = [];

    this.GetInstanceListDropdown();
  }

  public GetInstanceListDropdown() {
    if (!this.templateHashId && this.model.customerHashId) {
      this.instanceService
        .GetInstanceListDropdownForAddUpdatePage(
          this.pageName,
          this.permissionType,
          this.model.customerHashId
        )
        .subscribe(
          (res: any) => {
            this.InstanceList = res.data;

            if (this.InstanceList != null && this.InstanceList.length > 0) {
              if (!this.model.instanceHashId && this.InstanceList.length == 1) {
                this.model.instanceHashId = this.InstanceList[0].keyHash;
              }
              this.GetTemplateNames();
              this.OnInstanceChange();
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.GetTemplateNames();
    }
  }

  public OnInstanceChange(): any {
    this.model.companyHashId = "";
    this.CompanyList = [];
    this.model.organizationHashId = "";
    this.OrganizationList = [];
    this.model.svgHashId = "";
    this.SVGList = [];
    this.GetCompanyListDropdown();
  }

  public GetCompanyListDropdown() {
    if (
      !this.templateHashId &&
      this.model.customerHashId &&
      this.model.instanceHashId
    ) {
      this.companyService
        .GetCompanyListDropdownForAddUpdatePage(
          this.pageName,
          this.permissionType,
          this.model.instanceHashId
        )
        .subscribe(
          (res: any) => {
            this.CompanyList = res.data;

            if (this.CompanyList != null && this.CompanyList.length > 0) {
              if (!this.model.companyHashId && this.CompanyList.length == 1) {
                this.model.companyHashId = this.CompanyList[0].keyHash;
              }
              this.GetTemplateNames();
              this.OnCompanyChange();
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.GetTemplateNames();
    }
  }

  public OnCompanyChange(): any {
    this.model.organizationHashId = "";
    this.OrganizationList = [];
    this.model.svgHashId = "";
    this.SVGList = [];
    this.GetOrganizationListDropdown();
  }

  public GetOrganizationListDropdown() {
    if (
      !this.templateHashId &&
      ((this.model.customerHashId &&
        this.model.instanceHashId &&
        this.model.companyHashId)
        || (this.CompanyList.length > 1 && (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)))
      )
    ) {
      this.organizationService
        .GetOrganizationListDropdownForAddUpdatePage(
          this.pageName,
          this.permissionType,
          null,
          this.model.companyHashId
        )
        .subscribe(
          (res: any) => {
            this.OrganizationList = res.data;

            if (
              this.OrganizationList != null &&
              this.OrganizationList.length > 0
            ) {
              if (
                !this.model.organizationHashId &&
                this.OrganizationList.length == 1
              ) {
                this.model.organizationHashId = this.OrganizationList[0].keyHash;
              }
              this.GetTemplateNames();
              this.OnOrganizationChange();
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.GetTemplateNames();
    }
  }

  public OnOrganizationChange(): any {
    this.model.svgHashId = "";
    this.SVGList = [];
    this.GetSVGListDropdown();
  }

  public GetSVGListDropdown() {
    if (
      !this.templateHashId &&
      ((this.model.customerHashId &&
        this.model.instanceHashId &&
        this.model.companyHashId) || !(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)) &&
      this.model.organizationHashId
    ) {
      this.sharedVehicleGroupService
        .GetSharedVehicleDropdownListByOrganization(
          this.pageName,
          this.permissionType,
          this.model.organizationHashId
        )
        .subscribe(
          (res: any) => {
            this.SVGList = res.data;

            if (this.SVGList != null && this.SVGList.length > 0) {
              if (!this.model.svgHashId && this.SVGList.length == 1) {
                this.model.svgHashId = this.SVGList[0].keyHash;
              }
              this.GetTemplateNames();
              // On change TODO
            }
          },
          (error: any) => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.GetTemplateNames();
    }
  }

  public GeneratePdf() {
    this.templateService
      .GenerateLatexSamplePDF(
        this.model.templateHashID,
        this.model.instanceHashId,
        this.sampleDate
      )
      .subscribe(
        (res: any) => {
          if (res && res.data) {
            this.DownloadPdf(res.data);
          } else {
            this.isLatexFileDownloadFail = true;
          }
        },
        (error: any) => {
          this.isLatexFileDownloadFail = true;
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public DownloadPdf(fileName: string) {
    this.isLoading = true;
    this.templateService.DownloadLatexSamplePDF(fileName).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Sample" + new Date().toISOString() + ".pdf";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnTemplateNameChange(): any {
    this.TemplateNameChange();
  }

  public TemplateNameChange() {
    if (!this.isEditMode && this.model && this.model.emailTemplateNameHashId) {
      this.templateService
        .GetMasterTemplateByHashId(this.model.emailTemplateNameHashId)
        .subscribe(
          res => {
            let customerHashId = this.model.customerHashId;
            let instanceHashId = this.model.instanceHashId;
            let companyHashId = this.model.companyHashId;
            let organizationHashId = this.model.organizationHashId;
            let svgHashId = this.model.svgHashId;

            this.model = res.data;
            this.model.templateHashID = "";
            this.model.customerHashId = customerHashId;
            this.model.instanceHashId = instanceHashId;
            this.model.companyHashId = companyHashId;
            this.model.organizationHashId = organizationHashId;
            this.model.svgHashId = svgHashId;
            this.GetGetTemplateRecipients();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    }
  }

  public GetGetTemplateRecipients(): any {
    if (
      this.model &&
      this.model.emailTemplateNameHashId &&
      this.model.customerHashId
    ) {
      this.templateService
        .GetTemplateRecipients(
          this.model.customerHashId,
          this.model.emailTemplateNameHashId
        )
        .subscribe(
          res => {
            this.model.emailRecipients = res.data;
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/template/components/template-update.component.ts